/**
 * Archive a project as Flow does it (Projects list, project Home): archived first (only its owner may: a refusal stops
 * nothing), then its running services stopped with Stop all's own path (projectRun stopProject). Resolves to the
 * archive's answer with `stopError` (a service that did not stop: the project stays archived, say it).
 */
import { getProjectServices } from '../../services/SandboxService';
import { archiveProject } from '../../services/ProjectArchiveService';
import { runItems, stopProject } from './projectRun';

export async function archiveAndStop(projectId) {
  const answer = await archiveProject(projectId);
  let stopError = null;
  const services = await getProjectServices(projectId).catch(() => null);
  if (services && services.canRun !== false) {
    ({ error: stopError } = await stopProject(projectId, runItems(services)));
  }
  return { ...answer, stopError };
}

/** What archiving does, for its confirmations. */
export const ARCHIVE_EFFECTS = [
  'It is hidden from Projects, Home, workspaces, search and AI tools, for you and everyone it is shared with.',
  'Its running services are stopped.',
  'Nothing is deleted: find it under Projects › Archived and unarchive it any time.',
];
